import { useAppDispatch, useAppSelector } from '../../../../../lib/store';
import { selectGroupBy } from '../../../state/selector';
import { setGroupBy } from '../../../state/supervisorSlice';

export interface UseGroupBySectionResult {
  groupBy: string;
  handleGroupByChange: (value: string) => void;
}

export const useGroupBySection = (): UseGroupBySectionResult => {
  const dispatch = useAppDispatch();
  const groupBy = useAppSelector(selectGroupBy);

  const handleGroupByChange = (value: string) => {
    dispatch(setGroupBy(value));
  };
  return { groupBy, handleGroupByChange };
};
